
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable ,  BehaviorSubject } from 'rxjs';


import {RIAHelper} from '../core'
import {environment} from '../../environments/environment'
import { AuditStd_DateRangeRules } from './models/rate-audit-settings-model'

@Injectable()
export class RateAuditSettingsService {
  private RIABASE_URL: string = environment.baseWebApiUrl + 'api/RIA/';

  constructor(private http: Http) {
    //
  }

  public Get() {
    let  service = 'GetAuditStdDateRangeRules';
    return this.http
      .get(this.RIABASE_URL+service).pipe(
      map((response) => response.json()),
      map((response) => {
        return response ? response : null;
      }),);
  }

  public Save(auditStdDateRangeRules) {
    let service = 'AddUpdateAuditStdDateRangeRules';
    return this.http
    .post(this.RIABASE_URL+service, auditStdDateRangeRules);
  }
}


